import { useMemoize, asyncComputed } from "@vueuse/core";
import { restClient } from "../lib/raftApi";
// eslint-disable-next-line import/no-extraneous-dependencies, import/no-unresolved

const getModules = useMemoize(async () => {
  const path = "/sites/default/files/js/custom-modules.json";
  const blob = await restClient
    .cancelRequest(path)
    .downloadFile(path)
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error(e);
    });
  let response = null;
  try {
    response = JSON.parse(await blob.text());
  } catch (e) {
    const message = `Couldn't detect which modules are enabled. ${e.message}`;
    // eslint-disable-next-line
    console.error(message);
    response = { error: message };
  }
  return response;
});

/**
 * @type {import('vue').Ref<object|null>}
 */
const modulesEnabled = asyncComputed(() => getModules());

getModules();

// eslint-disable-next-line import/prefer-default-export
export function useModulesEnabled() {
  return {
    modulesEnabled,
    getModules,
  };
}
